const gql = String.raw;

const listQueries = {
  getListContactIds: gql`
    query ($listId: BigInt!) {
      getListContactIds(listId: $listId)
    }
  `,
};

export const preparedContactIdQuery = (contactIds) => {
  return {
    must: [
      {
        id: {
          in: [...contactIds],
        },
      },
    ],
  };
};

export default listQueries;
